import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import { QuestionCircleFill } from "react-bootstrap-icons";

export const ConfirmModal = ({ title, text, handleOk, handleClose }) => (
  <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title className="d-flex">
        <QuestionCircleFill className="align-self-center me-2 text-info" />
        <span>{title}</span>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>{text}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        <FormattedMessage id="component.common.modal.button.cancel" />
      </Button>
      <Button variant="primary" onClick={handleOk}>
        <FormattedMessage id="component.common.modal.button.ok" />
      </Button>
    </Modal.Footer>
  </Modal>
);

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
